import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { ThemeProvider } from "../../../components/ThemeProvider";
import { EnergySaving } from "./EnergySaving";
export var ThemeConnectedEnergySaving = memo(function () {
    return (_jsx(ThemeProvider, { children: _jsx(EnergySaving, {}) }));
});
